import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--system-black-opacity-6);
  z-index: 3;
  opacity: ${({ isOpen }) => !isOpen && '0'};

  transition: all cubic-bezier(0.15, 0.82, 1, 1) 0.2s;
  pointer-events: ${({ isOpen }) => !isOpen && 'none'};
  width: 100vw;
  height: 100vh;

  @media (max-width: 768px) {
    z-index: ${({ zIndex }) => zIndex};
  }
`;
